import focusElement from "./focus-element";

/**
 * 聚焦自定义积木的某个参数
 * @param args.index 第几个参数
 * @param {...} args 其他参数与focusElement保持一致
 */
export default function focusCustomProcedureArg(args) {
    return focusElement({element: "[class^=custom-procedures_workspace] [data-id]>[data-id][data-argument-type]", pointerEvents: 'none', ...args});
}
